import { render, staticRenderFns } from "./ReleaseConceptField.vue?vue&type=template&id=7437e211&"
import script from "./ReleaseConceptField.vue?vue&type=script&lang=js&"
export * from "./ReleaseConceptField.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseConceptField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports